import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FormikProps } from 'formik';
import { cleanObj } from '../../../../../shared/utils/objects';
import { ToastSwal } from '../../../../components/general/toastSwals/toastSwal';
import {
    Attachment,
    ISelect,
    ParamEnum,
} from '../../../../../shared/types/shared';
import {
    Pqr,
    PqrClosing,
    PqrData,
    PqrDataSfc,
    PqrFinalCausality,
    PqrInFavorOf,
    PqrInitialCausality,
    PqrNotificationClient,
    PqrProductData,
    PqrReconsideration,
    PqrRedirect,
    PqrResponseMedium,
    PqrStatusManagement2,
    PqrStrategicAlly,
    PqrHistorical,
} from '../../../../../shared/types/modules/pqr';
import {
    asyncCreatePqr,
    asyncGetPqr,
    asyncUpdatePqr,
    asyncGetPqrHistorical,
} from '../../../../../services/pqr.service';
import { PQR, PQR_DETAIL, SAMPLES_DETAIL } from '../../../../../routes/paths';
import { PqrHeadInfo } from './headInfo/props';
import { asyncGetParamById } from '../../../../../services/param.service';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { asyncGetAlerts } from '../../../../../services/alerts.service';
import {
    AlertsFilter,
    Alerts,
} from '../../../../../shared/types/legalProceedings/alerts';

dayjs.extend(utc);
dayjs.extend(timezone);

export const usePqrFormEdit = (showHistorical: boolean, isSample?: boolean) => {
    const navigate = useNavigate();
    const { idPqr } = useParams();
    const { idAccount } = useParams();
    const [pqr, setPqr] = useState<Pqr>();
    const [loading, setLoading] = useState(false);
    const [isWorngMovement, setIsWorngMovement] = useState<boolean>(false);
    const [formikPqrHeadInfo, setFormikPqrHeadInfo] =
        useState<FormikProps<PqrHeadInfo>>();
    const [formikPqrData, setFormikPqrData] = useState<FormikProps<PqrData>>();
    const [currentStatus, setCurrentStatus] = useState<ISelect>();
    const [formikPqrDataSfc, setFormikPqrDataSfc] =
        useState<FormikProps<PqrDataSfc>>();
    const [formikPqrInitialCausality, setFormikPqrInitialCausality] =
        useState<FormikProps<PqrInitialCausality>>();
    const [formikPqrNotificationClient, setFormikPqrNotificationClient] =
        useState<FormikProps<PqrNotificationClient>>();
    const [formikPqrReconsideration, setFormikPqrReconsideration] =
        useState<FormikProps<PqrReconsideration>>();
    const [formikPqrProductData, setFormikPqrProductData] =
        useState<FormikProps<PqrProductData>>();
    const [formikPqrStrategicAlly, setFormikPqrStrategicAlly] =
        useState<FormikProps<PqrStrategicAlly>>();
    const [formikPqrRedirect, setFormikPqrRedirect] =
        useState<FormikProps<PqrRedirect>>();
    const [formikPqrStatusManagement, setFormikPqrStatusManagement] =
        useState<FormikProps<PqrStatusManagement2>>();
    const [formikPqrInFavorOf, setFormikPqrInFavorOf] =
        useState<FormikProps<PqrInFavorOf>>();
    const [formikPqrFinalCausality, setFormikPqrFinalCausality] =
        useState<FormikProps<PqrFinalCausality>>();
    const [formikPqrResponseMedium, setFormikPqrResponseMedium] =
        useState<FormikProps<PqrResponseMedium>>();
    const [formikPqrClosing, setFormikPqrClosing] =
        useState<FormikProps<PqrClosing>>();
    const [attachments, setAttachments] = useState<Attachment[]>([]);
    const [statusCode, setStatusCode] = useState<string>('');
    const [isClousureStatus, setIsClousureStatus] = useState<boolean>(false);
    const clousureStatus = [
        `${ParamEnum.PQR_STATUS}_SOL`,
        `${ParamEnum.PQR_STATUS}_CER`,
    ];

    const [receptionChannel, setReceptionchannel] = useState<ISelect>();

    const isPhysicalReceptionChannel =
        receptionChannel?.code === `${ParamEnum.PQR_RECEPTION_CHANNEL}_FSC`;
    const isEmailReceptionChannel =
        receptionChannel?.code === `${ParamEnum.PQR_RECEPTION_CHANNEL}_EML`;
    const isFaxReceptionChannel =
        receptionChannel?.code === `${ParamEnum.PQR_RECEPTION_CHANNEL}_FAX`;
    const isSocialMediaReceptionChannel =
        receptionChannel?.code === `${ParamEnum.PQR_RECEPTION_CHANNEL}_RSL`;
    const [isOpenErrorSFCModal, setIsOpenErrorSFCModal] = useState(false);
    const [responseSmart, setResponseSmart] = useState();

    const [pqrHistorical, setPqrHistorical] = useState<PqrHistorical[]>();

    const [isCausalityFraud, setIsCausalityFraud] = useState(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [message, setMessage] = useState<string>();
    const [alert, setAlert] = useState<Alerts>();

    const [initialCausalityCurrent, setInitialCausalityCurrent] = useState<
        string | undefined
    >(undefined);

    const isValidForm =
        formikPqrHeadInfo?.isValid &&
        formikPqrData?.isValid &&
        formikPqrDataSfc?.isValid &&
        formikPqrInitialCausality?.isValid &&
        formikPqrNotificationClient?.isValid &&
        formikPqrReconsideration?.isValid &&
        formikPqrProductData?.isValid &&
        formikPqrStrategicAlly?.isValid &&
        formikPqrStatusManagement?.isValid &&
        formikPqrRedirect?.isValid &&
        formikPqrInFavorOf?.isValid &&
        formikPqrFinalCausality?.isValid &&
        formikPqrResponseMedium?.isValid &&
        formikPqrClosing?.isValid;

    const handleSubmit = async (e?: any) => {
        await formikPqrHeadInfo?.submitForm();
        await formikPqrData?.submitForm();
        await formikPqrDataSfc?.submitForm();
        await formikPqrInitialCausality?.submitForm();
        await formikPqrNotificationClient?.submitForm();
        await formikPqrReconsideration?.submitForm();
        await formikPqrProductData?.submitForm();
        await formikPqrStrategicAlly?.submitForm();
        await formikPqrStatusManagement?.submitForm();
        await formikPqrRedirect?.submitForm();
        await formikPqrInFavorOf?.submitForm();
        await formikPqrFinalCausality?.submitForm();
        await formikPqrResponseMedium?.submitForm();
        await formikPqrClosing?.submitForm();

        if (!isValidForm || isWorngMovement || !e) return;

        setLoading(true);
        const data: Pqr = {};
        data.account = pqr?.account?.id || idAccount;
        data.data = cleanObj(formikPqrData?.values);
        data.dataSfc = cleanObj(formikPqrDataSfc?.values);
        data.initialCausality = cleanObj(formikPqrInitialCausality?.values);
        data.notificationClients = cleanObj(
            formikPqrNotificationClient?.values
        );
        data.reconsideration = cleanObj(formikPqrReconsideration?.values);
        data.productData = cleanObj(formikPqrProductData?.values);
        data.strategicAlly = cleanObj(formikPqrStrategicAlly?.values);
        delete (data.strategicAlly as any).strategicAllyLabel;
        data.attachments = attachments;
        data.statusManagement = cleanObj(formikPqrStatusManagement?.values);
        data.redirect = cleanObj(formikPqrRedirect?.values);
        data.inFavorOf = cleanObj(formikPqrInFavorOf?.values);
        data.finalCausality = cleanObj(formikPqrFinalCausality?.values);
        data.responseMedium = cleanObj(formikPqrResponseMedium?.values);
        data.closing = cleanObj(formikPqrClosing?.values);
        data.alert = alert?.id;
        data.initialCausalityCurrent = initialCausalityCurrent;

        if (pqr && pqr.id && pqr.info)
            data.info = {
                ...pqr.info,
                country: (formikPqrDataSfc?.values as { country?: string })
                    .country as string,
                location: (formikPqrDataSfc?.values as { location?: string })
                    .location as string,
                correspondenceFiling: pqr.info?.correspondenceFiling as string,
                status: formikPqrStatusManagement?.values.status as string,
                detail: formikPqrHeadInfo?.values.detail,
            };

        let res: Pqr | undefined = undefined;

        try {
            if (pqr && pqr.id) res = await asyncUpdatePqr(pqr.id, data);
            else res = await asyncCreatePqr(data);
        } catch (error) {}
        if (res) {
            if (res?.responseSmart?.res?.status_code === 400) {
                setResponseSmart(res.responseSmart.res);
                setIsOpenErrorSFCModal(true);
            } else {
                navigate(`${isSample ? SAMPLES_DETAIL : PQR_DETAIL}/${res.id}`);
            }

            ToastSwal.fire({
                text: `¡Felicidades! El PQR se ${
                    pqr && pqr.id ? 'actualizo' : 'creó'
                } satisfactoriamente.`,
                icon: 'success',
                timer: 5000,
                position: 'center-end',
            });
        } else {
            ToastSwal.fire({
                text: `Lo sentimos, no se pudo ${
                    pqr && pqr.id ? 'actualizar' : 'crear'
                } el PQR. Por favor, asegúrate de ${
                    pqr && pqr.id
                        ? 'diligenciar los datos correctamente'
                        : 'que no exista previamente'
                } e intenta nuevamente más tarde.`,
                icon: 'error',
                timer: 5000,
                position: 'center-end',
            });
        }

        setLoading(false);
    };

    const handleClean = () => {
        formikPqrData?.resetForm();
        formikPqrDataSfc?.resetForm();
        formikPqrInitialCausality?.resetForm();
        formikPqrNotificationClient?.resetForm();
        formikPqrReconsideration?.resetForm();
        formikPqrProductData?.resetForm();
        formikPqrStrategicAlly?.resetForm();
        formikPqrStatusManagement?.resetForm();
        formikPqrRedirect?.resetForm();
        formikPqrInFavorOf?.resetForm();
        formikPqrFinalCausality?.resetForm();
        formikPqrResponseMedium?.resetForm();
        formikPqrClosing?.resetForm();
    };

    const onIsWorngMovement = (isWorngMovement: boolean) => {
        setIsWorngMovement(isWorngMovement);
    };

    const resetInitialCausality = () => {
        const f = formikPqrInitialCausality;
        if (!f) return;

        f.setValues({
            ...f.values,
            product: '',
            motive: '',
            submotive1: '',
            submotive2: '',
            submotive3: '',
            submotive4: '',
        });

        const fields = [
            'product',
            'motive',
            'submotive1',
            'submotive2',
            'submotive3',
            'submotive4',
        ] as const;

        fields.forEach((k) => {
            f.setFieldTouched(k, false, false);
            f.setFieldError(k, undefined as any);
        });

        setIsCausalityFraud(false);
    };

    const onProductChange = (value: string) => {
        const f = formikPqrInitialCausality;
        if (!f) return;
        f.setFieldValue('product', value);
        f.setFieldValue('motive', '');
        f.setFieldValue('submotive1', '');
        f.setFieldValue('submotive2', '');
        f.setFieldValue('submotive3', '');
        f.setFieldValue('submotive4', '');
        (
            [
                'motive',
                'submotive1',
                'submotive2',
                'submotive3',
                'submotive4',
            ] as const
        ).forEach((k) => {
            f.setFieldTouched(k, false, false);
            f.setFieldError(k, undefined as any);
        });
        setIsCausalityFraud(false);
    };

    useEffect(() => {
        if (Boolean(idPqr?.trim())) {
            setLoading(true);
            asyncGetPqr(idPqr?.trim())
                .then((pqr) => {
                    if (!pqr || !pqr.id) navigate(PQR);
                    [
                        pqr?.data,
                        pqr?.dataSfc,
                        pqr?.initialCausality ?? pqr?.initialCausalityCurrent,
                        pqr?.info,
                        pqr?.reconsideration,
                        pqr?.redirect,
                        pqr?.inFavorOf,
                        pqr?.finalCausality,
                        pqr?.responseMedium,
                        pqr?.closing,
                    ].forEach((item: any) => {
                        if (item)
                            Object.keys(item).forEach((key) => {
                                if (item?.[key] && (item?.[key] as ISelect)?.id)
                                    item[key] = (
                                        item[key] as ISelect
                                    )?.id.toString();
                            });
                    });
                    setPqr(pqr);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqr]);

    useEffect(() => {
        const status = formikPqrStatusManagement?.values?.status as string;
        if (status) {
            asyncGetParamById(status).then((item) => {
                setCurrentStatus(item);
            });
        }
    }, [formikPqrStatusManagement?.values?.status]);

    useEffect(() => {
        const redirect = formikPqrRedirect?.values?.redirectPqr;
        if (
            formikPqrRedirect &&
            formikPqrRedirect.setFieldValue &&
            formikPqrStatusManagement &&
            currentStatus &&
            currentStatus.code === `${ParamEnum.PQR_STATUS}_TRA` &&
            redirect !== true
        ) {
            formikPqrRedirect.setFieldValue('redirectPqr', true);
        }
    }, [
        formikPqrRedirect?.values?.redirectPqr,
        formikPqrStatusManagement?.values?.status,
        formikPqrRedirect,
        formikPqrStatusManagement,
        currentStatus,
    ]);

    useEffect(() => {
        if (formikPqrStatusManagement?.values.status)
            asyncGetParamById(
                formikPqrStatusManagement?.values.status as string
            ).then((item) => {
                setIsClousureStatus(
                    item?.code && clousureStatus.includes(item?.code)
                        ? true
                        : false
                );
            });
    }, [formikPqrStatusManagement?.values.status]);

    useEffect(() => {
        if (!isOpenErrorSFCModal && responseSmart) {
            navigate(`${isSample ? SAMPLES_DETAIL : PQR_DETAIL}/${idPqr}`);
        }
    }, [isOpenErrorSFCModal]);

    useEffect(() => {
        if (formikPqrData?.values.receptionChannel)
            asyncGetParamById(
                formikPqrData?.values.receptionChannel as string
            ).then((item) => {
                setReceptionchannel(item);
            });
    }, [formikPqrData?.values.receptionChannel]);

    useEffect(() => {
        if (Boolean(idPqr?.trim()) && showHistorical) {
            setLoading(true);
            asyncGetPqrHistorical(idPqr?.trim())
                .then((resp) => {
                    if (resp) setPqrHistorical(resp);
                    else navigate(PQR);
                })
                .finally(() => setLoading(false));
        }
    }, [idPqr, showHistorical]);

    useEffect(() => {
        if (formikPqrStatusManagement?.values.status)
            asyncGetParamById(
                formikPqrStatusManagement?.values.status as string
            ).then((items) => setStatusCode(items?.code ?? ''));
    }, [formikPqrStatusManagement?.values.status]);

    useEffect(() => {
        if (
            !formikPqrStatusManagement?.values.status ||
            !formikPqrData?.values.receptionChannel ||
            !formikPqrData?.values.type ||
            !formikPqrData?.values.half ||
            !formikPqrData?.values.subtypeDp ||
            !formikPqrData?.values.procedure
        ) {
            return;
        }

        const filters: AlertsFilter = {
            status: formikPqrStatusManagement?.values.status,
            receptionChannel: formikPqrData?.values.receptionChannel,
            typePQR: formikPqrData?.values.type,
            receivedThrough: formikPqrData?.values.half,
            subtypeDP: formikPqrData?.values.subtypeDp,
            transaction: formikPqrData?.values.procedure,
        };
        if (
            filters.status &&
            filters.receptionChannel &&
            filters.typePQR &&
            filters.receivedThrough &&
            filters.subtypeDP &&
            filters.transaction
        ) {
        }

        try {
            asyncGetAlerts({
                status: formikPqrStatusManagement?.values.status || '',
                receptionChannel: formikPqrData?.values.receptionChannel || '',
                typePQR: formikPqrData?.values.type || '',
                receivedThrough: formikPqrData?.values.half || '',
                subtypeDP: formikPqrData?.values.subtypeDp || '',
                transaction: formikPqrData?.values.procedure || '',
                active: true,
            }).then(({ items }) => {
                if (items.length > 0 && items[0]) {
                    const alert = items[0];
                    setAlert(alert);
                    setIsOpen(false);
                } else {
                    setMessage(`
                        No existe una <strong>Reglas Alertas</strong> asociada a esta combinación:
                        <ul style="margin-top: 8px; margin-bottom: 8px; padding-left: 20px;">
                            <li><strong>Estado de la Regla</strong></li>
                            <li><strong>Canal de Recepción</strong></li>
                            <li><strong>Tipo PQR</strong></li>
                            <li><strong>Medio</strong></li>
                            <li><strong>Subtipo DP</strong></li>
                            <li><strong>Trámite</strong></li>
                        </ul>
                    `);
                    setIsOpen(true);
                    setAlert({} as Alerts);
                }
            });
        } catch (error) {
            setAlert({} as Alerts);
            setIsOpen(false);
        }
    }, [
        formikPqrData?.values.half,
        formikPqrData?.values.subtypeDp,
        formikPqrData?.values.procedure,
        formikPqrData?.values.type,
        formikPqrData?.values.receptionChannel,
        formikPqrStatusManagement?.values.status,
    ]);

    const handleClose = () => {
        setIsOpen(false);
    };
    return {
        pqr,
        idAccount,
        loading,
        isValidForm,
        handleSubmit,
        handleClean,
        formikPqrData,
        formikPqrDataSfc,
        formikPqrInitialCausality,
        formikPqrNotificationClient,
        formikPqrReconsideration,
        formikPqrProductData,
        formikPqrStrategicAlly,
        formikPqrStatusManagement,
        formikPqrInFavorOf,
        formikPqrClosing,
        attachments,
        setFormikPqrData,
        setFormikPqrDataSfc,
        setFormikPqrInitialCausality,
        setFormikPqrNotificationClient,
        setFormikPqrStatusManagement,
        setFormikPqrReconsideration,
        setFormikPqrProductData,
        setFormikPqrStrategicAlly,
        setAttachments,
        setFormikPqrRedirect,
        setFormikPqrInFavorOf,
        setFormikPqrFinalCausality,
        setFormikPqrResponseMedium,
        setFormikPqrClosing,
        setFormikPqrHeadInfo,
        setInitialCausalityCurrent,
        isClousureStatus,
        isPhysicalReceptionChannel,
        isEmailReceptionChannel,
        isFaxReceptionChannel,
        isSocialMediaReceptionChannel,
        isOpenErrorSFCModal,
        setIsOpenErrorSFCModal,
        responseSmart,
        onIsWorngMovement,
        pqrHistorical,
        statusCode,
        isCausalityFraud,
        setIsCausalityFraud,
        resetInitialCausality,
        onProductChange,
        isOpen,
        handleClose,
        message,
    };
};
